"use client";

import { ProductVariant } from "@/api/generated-api";
import VariantOptionBaseView, { VariantOptionViewItem } from "./variant-option-base-view";

interface VariantOptionProductGroupProps {
  title: string;
  items: ProductVariant[];
  selectedId?: number;
  onSelect: (id: number) => void;
}

const VariantOptionProductGroup = ({ title, items, selectedId, onSelect }: VariantOptionProductGroupProps) => {
  const viewItems: VariantOptionViewItem[] = items.map(item => ({
    key: item.product_id,
    title: item.title,
    colour: item.colour,
  }));

  return <VariantOptionBaseView title={title} items={viewItems} selectedKey={selectedId} onSelect={onSelect} />;
};

export default VariantOptionProductGroup;
